import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Stack
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import CopyrightIcon from '@mui/icons-material/Copyright';
import SideMenuDrawer from './SideMenuDrawer'; // 👈 추가된 import

const menuItems = [
  { label: '홈', isActive: true },
  { label: 'POST' },
  { label: '우리동네 공부방' },
  // { label: '커뮤니티', hasDot: true },
  // { label: '오디오북' },
  { label: '핫 이슈', hasDot: true  },
  // { label: '이벤트' },
];

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (open: boolean) => () => setDrawerOpen(open);

  return (
    <>
      <AppBar position="static" color="transparent" elevation={0} 
              sx={{ borderBottom: '1px solid #fefefe', width: '100%', boxShadow: '0 2px 0 rgba(0, 0, 0, 0.05)', margin: 0, padding: 0 }}>
        <Toolbar sx={{ justifyContent: 'space-between',  }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#f3e521ff' }} />
            <Typography variant="h6" fontWeight="bold">
              groubee
            </Typography>
          </Box>

          <Stack
            direction="row"
            spacing={3}
            alignItems="center"
            sx={{ display: { xs: 'none', md: 'flex' } }} // ✅ 모바일에서는 숨김
          >
          {menuItems.map(({ label, isActive, hasDot }) => (
            <Box key={label} sx={{ position: 'relative' }}>
              <Typography
                sx={{
                  fontWeight: isActive ? 'bold' : 400,
                  color: isActive ? 'black' : '#555',
                  fontSize: '0.95rem',
                }}
              >
                {label}
              </Typography>
              {hasDot && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: -4,
                    right: -8,
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: 'red',
                  }}
                />
              )}
            </Box>
          ))}
        </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            {/* <IconButton>
              <CopyrightIcon sx={{ color: 'gold' }} />
            </IconButton> */}
            <IconButton>
              <SearchIcon />
            </IconButton>
            <IconButton onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>

      <SideMenuDrawer
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        menuItems={menuItems} // 👈 메뉴 전달
      />

    </>
  );
};

export default Header;
